// DO NOT USE THIS FOR INTER-COMP COMMUNICATION UNLESS YOU'VE SPOKEN TO JOSH
// This is mostly for global events that other integrations may be interested in, or areas where you'd have to pass junk multiple levels
import mitt from 'mitt'
const emitter = mitt()

export default ({ app }, inject) => {
    inject('uiEvents', {
        $on: emitter.on,
        $off: emitter.off,
        $emit: emitter.emit,
    })

    // This is here because it needs access to uiEvents (router.js doesn't)
    app.router.afterEach((to, from) => {
        // not sure if we really need the delay, but it's consistent with below
        // using an obj for the event for easy upgrades later, using to vs { route } really so consumers can use the same listeners for initial hits & route changes
        if (from.name === null) {
            setTimeout(() => {
                app.$uiEvents.$emit('firstLoaded', { to })
                checkProductHit(to, from)
            }, 1000)
            return
        }

        // if you are coming to, from a route with a query string, just ignore.. we are concerned with path changes
        // this would fire for /c/mud-flaps/ > /c/mud-flaps/chevy/silverado-1500/2010/
        if (to.path === from.path) return

        // At the time this is called (afterEach) the title and url are still the old ones.. Wait :(
        // https://github.com/nuxt/vue-meta/issues/259
        // https://github.com/vuejs/vue-router/issues/1197
        setTimeout(() => {
            app.$uiEvents.$emit('routeChanged', { to, from })
            checkProductHit(to, from)
        }, 1000)
    })

    // On the product page, mounted() and beforeRouteUpdate() get called multiple times and when you don't expect them (compared to plain Vue SPA)
    // Therefore, we are processing plain page hits here and telling the rest of integrations about them.  Here, we ignore changes in YMM too.
    function checkProductHit(to, from) {
        if (
            to.params.productLine &&
            (to.params.productLine !== from.params.productLine || from.params.skuSlug)
        )
            app.$uiEvents.$emit('productLineViewed')
    }
}

/*
  EVENTS

 Cart
 - orderPlaced
 - addToCart
 - removeFromCart

 Category Pages
 - facetClicked

 Product Pages
 - chooseOptionsClicked

 Menu
 - openMobileMenu
 - closeMobileMenu
 - closeMenu

 Global
 - routeChanged
 */
